
// Parent Modules
import { cardSlider } from '../../../../individual-restaurants/library/src/js/modules/card-slider';
//import { hero } from '../../../../individual-restaurants/library/src/js/modules/hero';
import { locationsList } from '../../../../individual-restaurants/library/src/js/modules/locations-list';
//import locationsSubnav from '../../../../individual-restaurants/library/src/js/modules/locations-subnav';
//import locationsSlider from '../../../../individual-restaurants/library/src/js/modules/locations-slider';
import { moduleMap } from '../../../../individual-restaurants/library/src/js/modules/map';
import { newsletterSignup } from '../../../../individual-restaurants/library/src/js/modules/newsletter-signup';
// import pressEventsFeed from '../../../../individual-restaurants/library/src/js/modules/press-events-feed';
import { promoSlider } from '../../../../individual-restaurants/library/src/js/modules/promo-slider';
//import storiesFeed from '../../../../individual-restaurants/library/src/js/modules/stories-feed';
import { imageSlider } from '../../../../individual-restaurants/library/src/js/modules/image-slider';
import { videoPlayer } from '../../../../individual-restaurants/library/src/js/modules/video-player';
import { moduleSpacesFeed } from '../../../../individual-restaurants/library/src/js/modules/private-event-spaces-feed';
import { moduleFuseFeed } from '../../../../individual-restaurants/library/src/js/modules/fuse-feed';
import { moduleMenus } from '../../../../individual-restaurants/library/src/js/modules/menus';
import { faqsJS } from '../../../../individual-restaurants/library/src/js/modules/faqs';
import { allergens } from '../../../../individual-restaurants/library/src/js/modules/allergens';


// Parent Functions (These really need to be split up into more descriptive folders)
import { header } from './components/header';
import { hoverVideo } from '../../../../individual-restaurants/library/src/js/functions/hover-video';
import { inlineVideo } from '../../../../individual-restaurants/library/src/js/functions/inline-video';
import { mainNav } from '../../../../individual-restaurants/library/src/js/functions/main-nav';
import { closePopupsButtonWatcher, hijackDMNForm, hijackOTForm, newsletterSignupForm, triggerCustomPopups } from '../../../../individual-restaurants/library/src/js/functions/popups';
import { urlParams } from '../../../../individual-restaurants/library/src/js/functions/url-params';

//Ignite OT Plugin - This JS is from ir-opentable plugin file, needs to be here due to Barba
import igOtBooking from '../../../../individual-restaurants/library/src/js/functions/ot-booking-widget';

//Child Theme Specific JS
import { fadeOnScroll } from './components/fade-on-scroll';
import { frontPageJs } from './pages/front-page';



export default initJS = () => {

	document.querySelector('body').classList.remove('no-js');
	document.querySelector('#js__body').classList.remove('no-js');

	//Modules
	cardSlider();
	locationsList();
	moduleMap();
	newsletterSignup();
	promoSlider();
	imageSlider();
	videoPlayer();
	moduleSpacesFeed();
	moduleFuseFeed();
	moduleMenus();
	faqsJS();
	allergens();

	//Global Parent Functions
	header();
	mainNav();
	closePopupsButtonWatcher();
	triggerCustomPopups();
	hijackDMNForm();
	hijackOTForm();
	newsletterSignupForm();
	urlParams();
	hoverVideo();
	inlineVideo();

	//Piccolino Specific
	fadeOnScroll();

	//Page specific
	frontPageJs();

	let igOtBw = new igOtBooking(document.querySelector('.ignite-ot-booking-widget'));
}